module.exports = __webpack_public_path__ + "img/avartar_ux.a2e89747.png";